import styled from "styled-components/macro";

export const Wrapper = styled.div`
  height: 1rem;
  padding: 0.2rem;
  cursor: pointer;
`;
